import Icon from "../../components/Icon";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

export default function WorkflowLimitBanner({ workflowLimit, activeWorkflowCount, currentPlan }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="bg-orange-50 border border-orange-200 rounded-lg p-6 mb-6">
            <div className="flex items-start">
                <Icon name="AlertTriangle" className="h-5 w-5 text-orange-600 flex-shrink-0" />
                <div className="ml-3">
                    <h3 className="text-sm font-medium text-orange-800">
                        {t("chatPage.workflowLimit.title")}
                    </h3>
                    <p className="mt-2 text-sm text-orange-700">
                        {t("chatPage.workflowLimit.message", {
                            limit: workflowLimit,
                            current: activeWorkflowCount,
                            plan: currentPlan,
                        })}
                    </p>
                    <button
                        onClick={() => {
                            localStorage.setItem("billing_return_url", location.pathname + location.search);
                            navigate("/billing");
                        }}
                        className="mt-4 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-orange-700 bg-orange-100 hover:bg-orange-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                    >
                        {t("chatPage.workflowLimit.upgradeNow")}
                    </button>
                </div>
            </div>
        </div>
    );
}
